import { Box } from '@chakra-ui/react'

export const Empty = () => {
  return (
    <Box textAlign='center' p={12}>
      Nothing found.
    </Box>
  )
}
